import {Stack} from '@mui/material';
import styled from 'styled-components';

const StyledStack = styled(Stack)`
	width: 100%;
	background-color: ${({theme}) => theme.colors.gray['10Percent']};
	padding: ${({theme}) => theme.spacing(2)};
	border-radius: ${({theme}) => theme.spacing(1)};
	gap: ${({theme}) => theme.spacing(1)};
`;

export {StyledStack};
